import { render, staticRenderFns } from "./BasicTable.vue?vue&type=template&id=506d5b7f&scoped=true&"
import script from "./BasicTable.vue?vue&type=script&lang=js&"
export * from "./BasicTable.vue?vue&type=script&lang=js&"
import style0 from "./BasicTable.vue?vue&type=style&index=0&id=506d5b7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506d5b7f",
  null
  
)

export default component.exports